import { 
  GET_BRAND, 
  GET_SEARCH_BRAND,
  POST_BRAND,
  UPDATE_BRAND,
  DELETE_BRAND,
 } from '../type'

const initialState = {
  listBrand: [],
  countBrand: 0,
  listSearch: []
}

const brand = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRAND:
      return {
        ...state,
        listBrand: action.data.data,
        countBrand: action.data.count
      }
    case GET_SEARCH_BRAND:
      return {
        ...state,
        listBrand: action.data,
      }
    case POST_BRAND:
      return {
        ...state,
        listBrand: [...state.listBrand, action.data,]
      } 
    case UPDATE_BRAND:
      return {
        ...state,
        listBrand: state.listBrand.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_BRAND:
      return {
        ...state,
        listBrand: state.listBrand.filter(
          (item) => item._id !== action.data.id 
        )
      }
    default:
      return state
  }
}

export default brand